import vjsSrv from './vjsSrv';
import Logger from '../logger';

export class AppPostersManager {
  constructor() {
    this.prevPoster = null;
    this.nextPoster = null;
    this.ANIMATION_TIMEOUT = 500;
    this.changePosterTimeoutID = null;
    this.stackEvents = [];
  }

  init() {
    vjsSrv.vjsPlayer.tech_.el_.addEventListener('posterAnimationEnd', this.eventListener.bind(this), false);
  }

  eventListener(event) {
    switch (event.type) {
      case 'posterAnimationEnd' :
        while (this.stackEvents.length) {
          let _opt = this.stackEvents.shift();
          this[_opt.method](_opt.options, true);
        }
    }
    event.preventDefault();
    event.stopPropagation();
  }

  // setPrevPoster(prevVideoOpt, isAfterAnimation) {
  //
  //   if (!this.prevPoster) {
  //     let posterImageComponent = videoJs.getComponent('posterImage');
  //     this.prevPoster = new posterImageComponent(vjsSrv.vjsPlayer);
  //     let currentPosterEl = vjsSrv.vjsPlayer.posterImage.el_;
  //     currentPosterEl.parentNode.insertBefore(this.prevPoster.el_, currentPosterEl);
  //   }
  //   if (this.changePosterTimeoutID && !isAfterAnimation) {
  //     this.stackEvents.push({
  //       timeoutId: this.changePosterTimeoutID,
  //       event: 'posterAnimationEnd',
  //       options: prevVideoOpt,
  //       method: 'setPrevPoster'
  //     });
  //     return;
  //   }
  //   this.prevPoster.posterPath = prevVideoOpt.extraData.poster;
  //   this.prevPoster.removeClass('vjs-poster');
  //   this.prevPoster.addClass('vjs-prev-poster');
  //   this.prevPoster.setSrc(prevVideoOpt.extraData.poster || '');
  // }

  // setNextPoster(nextVideoOpt, isAfterAnimation) {
  //   if (!this.nextPoster) {
  //     let posterImageComponent = videoJs.getComponent('posterImage');
  //     this.nextPoster = new posterImageComponent(vjsSrv.vjsPlayer);
  //     let currentPosterEl = vjsSrv.vjsPlayer.posterImage.el_;
  //     currentPosterEl.parentNode.insertBefore(this.nextPoster.el_, currentPosterEl.nextSibling);
  //   }
  //   if (this.changePosterTimeoutID && !isAfterAnimation) {
  //     this.stackEvents.push({
  //       timeoutId: this.changePosterTimeoutID,
  //       event: 'posterAnimationEnd',
  //       options: nextVideoOpt,
  //       method: 'setNextPoster'
  //     });
  //     return;
  //   }
  //   this.nextPoster.posterPath = nextVideoOpt.extraData.poster;
  //   this.nextPoster.removeClass('vjs-poster');
  //   this.nextPoster.addClass('vjs-next-poster');
  //   this.nextPoster.setSrc(nextVideoOpt.extraData.poster || '');
  //
  // }

  // onIMGLoaded(event) {
  //
  //   let timeStart = Date.now();
  //   let timeCorrelator = (timeStart + this.ANIMATION_TIMEOUT) - Date.now();
  //   setTimeout(() => {
  //     this._secondPoster.removeClass('vjs-start-animation');
  //     vjsSrv.vjsPlayer.posterImage.removeClass('vjs-leave-animation');
  //     vjsSrv.vjsPlayer.removeClass('vjs-animate-video');
  //
  //     this.changePosterTimeoutID = null;
  //     let _event = new Event('posterAnimationEnd');
  //     vjsSrv.vjsPlayer.tech_.el_.dispatchEvent(_event);
  //     //              delete tempImgTag;
  //   }, timeCorrelator > 0 ? timeCorrelator : 0);
  // }

  setCurrentPoster(asset, isAfterAnimation) {
    if (asset.extraData.poster) {
      vjsSrv.vjsPlayer.poster(asset.extraData.poster);
      // if (this.nextPoster && this.nextPoster.posterPath !== asset.extraData.poster) {
      //   this.setNextPoster(asset);
      // }
      //
      // if (vjsSrv.vjsPlayer.posterImage.posterPath === asset.extraData.poster) {
      //   return;
      // }
      //
      // if (this.changePosterTimeoutID && asset.extraData.poster !== vjsSrv.vjsPlayer.posterImage.posterPath &&
      //   !isAfterAnimation) {
      //   this.stackEvents.push({
      //     event: 'posterAnimationEnd',
      //     options: asset,
      //     method: 'setCurrentPoster'
      //   });
      //   return;
      // }
      // this._secondPoster = null;
      // // case when we click to next video on portal
      // if (this.nextPoster && this.nextPoster.posterPath === asset.extraData.poster) {
      //   this._secondPoster = this.nextPoster;
      // } else if (this.prevPoster && this.prevPoster.posterPath === asset.extraData.poster) {
      //   this._secondPoster = this.prevPoster;
      // }
      // if (this._secondPoster) {
      //   /** Animation */
      //   vjsSrv.vjsPlayer.addClass('vjs-animate-video');
      //   this._secondPoster.addClass('vjs-start-animation');
      //   vjsSrv.vjsPlayer.posterImage.addClass('vjs-leave-animation');
      //   vjsSrv.vjsPlayer.posterImage.posterPath = asset.extraData.poster;
      //
      //   // this.changePosterTimeoutID = true;
      //
      //
      //   // setTimeout(() => {
      //   //   vjsSrv.vjsPlayer.poster(asset.extraData.poster);
      //
      //     // let tempImgTag = document.createElement('img');
      //     // tempImgTag.src = asset.extraData.poster;
      //     // tempImgTag.addEventListener('load', this.onIMGLoaded.bind(this));
      //     // tempImgTag.addEventListener('error', this.onIMGLoaded.bind(this));
      //     // tempImgTag.addEventListener(['load', 'error'], (event) => {
      //     //   let timeCorrelator = (timeStart + this.ANIMATION_TIMEOUT) - Date.now();
      //     //   setTimeout(() => {
      //     //     secondPoster.removeClass('vjs-start-animation');
      //     //     vjsSrv.vjsPlayer.posterImage.removeClass('vjs-leave-animation');
      //     //     vjsSrv.vjsPlayer.removeClass('vjs-animate-video');
      //     //
      //     //     this.changePosterTimeoutID = null;
      //     //     let _event = new Event('posterAnimationEnd');
      //     //     vjsSrv.vjsPlayer.tech_.el_.dispatchEvent(_event);
      //     //     //              delete tempImgTag;
      //     //   }, timeCorrelator > 0 ? timeCorrelator : 0);
      //     // });
      //   // }, this.ANIMATION_TIMEOUT / 2);
      //
      // } else {
      //   // case if next poster is not exists or not install
      //   vjsSrv.vjsPlayer.posterImage.posterPath = asset.extraData.poster;
      //   vjsSrv.vjsPlayer.poster(asset.extraData.poster);
      // }
    } else {
      vjsSrv.vjsPlayer.posterImage.posterPath = '';
      vjsSrv.vjsPlayer.poster('');
    }
  }
}

const PostersManager = new AppPostersManager();
export default PostersManager;
// PostersManager._instance = null;
// PostersManager.getInstance = () => {
//   if(!PostersManager._instance) {
//     PostersManager._instance = new PostersManager();
//   }
//   return PostersManager._instance;
// };
